import { createReducer, on } from '@ngrx/store';
import * as OrderDefaultDataActions from './order-default-data.actions';

export interface OrderDefaultDataState {
  response: any | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: any };
}

export const initialState: OrderDefaultDataState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const orderDefaultDataReducer = createReducer(
  initialState,
  on(OrderDefaultDataActions.loadOrderDefaultData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OrderDefaultDataActions.loadOrderDefaultDataSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(OrderDefaultDataActions.loadOrderDefaultDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OrderDefaultDataActions.loadOrderDefaultDataSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
